require.context("../../assets/images", true);
import "bootstrap";
import "animate.css/animate.css";
import "assets/stylesheets/application.scss";
import App from "./application/app";

window.app = new App();
